import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Kiosk Pages
import KioskWelcome from "./pages/kiosk/KioskWelcome";
import KioskAttract from "./pages/kiosk/KioskAttract";
import KioskCategory from "./pages/kiosk/KioskCategory";
import KioskForm from "./pages/kiosk/KioskForm";
import KioskBadgeCapture from "./pages/kiosk/KioskBadgeCapture";
import KioskBlueBadgeIntro from "./pages/kiosk/KioskBlueBadgeIntro";
import KioskBadgeScan from "./pages/kiosk/KioskBadgeScan";
import KioskBadgeReview from "./pages/kiosk/KioskBadgeReview";
import KioskProcessing from "./pages/kiosk/KioskProcessing";
import KioskConfirmation from "./pages/kiosk/KioskConfirmation";
import KioskLookup from "./pages/kiosk/KioskLookup";
import KioskStatus from "./pages/kiosk/KioskStatus";
import KioskPayParking from "./pages/kiosk/KioskPayParking";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminRegistrations from "./pages/admin/AdminRegistrations";
import AdminRegistrationDetail from "./pages/admin/AdminRegistrationDetail";
import AdminOCRExceptions from "./pages/admin/AdminOCRExceptions";
import AdminAuditLog from "./pages/admin/AdminAuditLog";
import AdminSites from "./pages/admin/AdminSites";
import AdminRetailers from "./pages/admin/AdminRetailers";
import AdminRewards from "./pages/admin/AdminRewards";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AuthCallback from "./pages/admin/AuthCallback";
// Phase 4 - Signage CMS
import AdminScreens from "./pages/admin/AdminScreens";
import AdminContent from "./pages/admin/AdminContent";
import AdminPlaylists from "./pages/admin/AdminPlaylists";
// Phase 5 - Revenue Modules
import AdminAdvertisers from "./pages/admin/AdminAdvertisers";
import AdminCampaigns from "./pages/admin/AdminCampaigns";
import AdminBilling from "./pages/admin/AdminBilling";
import AdminRevenue from "./pages/admin/AdminRevenue";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminEntitlements from "./pages/admin/AdminEntitlements";
import AdminEntitlementsV2 from "./pages/admin/AdminEntitlementsV2";
import AdminReceipts from "./pages/admin/AdminReceipts";
import AdminANPR from "./pages/admin/AdminANPR";
import AdminSystemStatus from "./pages/admin/AdminSystemStatus";
import AdminFreeflow from "./pages/admin/AdminFreeflow";
import AdminExitAuths from "./pages/admin/AdminExitAuths";
import AdminBarrierControl from "./pages/admin/AdminBarrierControl";
// Test Control Panel
import TestControlPanel from "./pages/admin/TestControlPanel";
// Advertising Management Module
import AdvertisingDashboard from "./pages/admin/advertising/AdvertisingDashboard";
import AdvertisingAdvertisers from "./pages/admin/advertising/AdvertisingAdvertisers";
import AdvertisingScreens from "./pages/admin/advertising/AdvertisingScreens";
import AdvertisingCampaigns from "./pages/admin/advertising/AdvertisingCampaigns";
import AdvertisingCalendar from "./pages/admin/advertising/AdvertisingCalendar";
import AdvertisingApprovals from "./pages/admin/advertising/AdvertisingApprovals";
import AdvertisingProofOfPlay from "./pages/admin/advertising/AdvertisingProofOfPlay";
import AdvertisingBilling from "./pages/admin/advertising/AdvertisingBilling";
// Advertiser Self-Service Portal
import AdvertiserLogin from "./pages/advertiser/AdvertiserLogin";
import AdvertiserDashboard from "./pages/advertiser/AdvertiserDashboard";
import AdvertiserCampaigns from "./pages/advertiser/AdvertiserCampaigns";
import CreateCampaign from "./pages/advertiser/CreateCampaign";
import CampaignDetail from "./pages/advertiser/CampaignDetail";
import AdvertiserBilling from "./pages/advertiser/AdvertiserBilling";

// Visit Pages (Mobile)
import VisitCapture from "./pages/visit/VisitCapture";
import VisitSuccess from "./pages/visit/VisitSuccess";

// Screen Player (Signage)
import ScreenPlayer from "./pages/player/ScreenPlayer";

import "@/App.css";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Landing redirect */}
      <Route path="/" element={<Navigate to="/kiosk" replace />} />
      
      {/* Kiosk Routes */}
      <Route path="/kiosk" element={<KioskWelcome />} />
      <Route path="/kiosk/attract" element={<KioskAttract />} />
      <Route path="/kiosk/lookup" element={<KioskLookup />} />
      <Route path="/kiosk/status" element={<KioskStatus />} />
      <Route path="/kiosk/category" element={<KioskCategory />} />
      <Route path="/kiosk/form" element={<KioskForm />} />
      <Route path="/kiosk/badge-capture" element={<KioskBadgeCapture />} />
      <Route path="/kiosk/badge-intro" element={<KioskBlueBadgeIntro />} />
      <Route path="/kiosk/badge-scan" element={<KioskBadgeScan />} />
      <Route path="/kiosk/badge-review" element={<KioskBadgeReview />} />
      <Route path="/kiosk/processing" element={<KioskProcessing />} />
      <Route path="/kiosk/confirmation" element={<KioskConfirmation />} />
      <Route path="/kiosk/pay" element={<KioskPayParking />} />
      
      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/registrations" element={<AdminRegistrations />} />
      <Route path="/admin/registrations/:id" element={<AdminRegistrationDetail />} />
      <Route path="/admin/sites" element={<AdminSites />} />
      <Route path="/admin/retailers" element={<AdminRetailers />} />
      <Route path="/admin/rewards" element={<AdminRewards />} />
      <Route path="/admin/analytics" element={<AdminAnalytics />} />
      <Route path="/admin/ocr-exceptions" element={<AdminOCRExceptions />} />
      <Route path="/admin/audit-log" element={<AdminAuditLog />} />
      {/* Phase 4 - Signage CMS */}
      <Route path="/admin/screens" element={<AdminScreens />} />
      <Route path="/admin/content" element={<AdminContent />} />
      <Route path="/admin/playlists" element={<AdminPlaylists />} />
      {/* Phase 5 - Revenue Modules */}
      <Route path="/admin/advertisers" element={<AdminAdvertisers />} />
      <Route path="/admin/campaigns" element={<AdminCampaigns />} />
      <Route path="/admin/billing" element={<AdminBilling />} />
      <Route path="/admin/billing/success" element={<AdminBilling />} />
      <Route path="/admin/billing/cancel" element={<AdminBilling />} />
      <Route path="/admin/revenue" element={<AdminRevenue />} />
      <Route path="/admin/settings" element={<AdminSettings />} />
      <Route path="/admin/entitlements" element={<AdminEntitlements />} />
      <Route path="/admin/entitlements-v2" element={<AdminEntitlementsV2 />} />
      <Route path="/admin/receipts" element={<AdminReceipts />} />
      <Route path="/admin/anpr" element={<AdminANPR />} />
      <Route path="/admin/system-status" element={<AdminSystemStatus />} />
      <Route path="/admin/freeflow" element={<AdminFreeflow />} />
      <Route path="/admin/exit-auths" element={<AdminExitAuths />} />
      <Route path="/admin/barrier" element={<AdminBarrierControl />} />
      <Route path="/admin/barrier-control" element={<AdminBarrierControl />} />
      <Route path="/admin/test" element={<TestControlPanel />} />
      <Route path="/admin/test-panel" element={<TestControlPanel />} />
      {/* Advertising Management Module */}
      <Route path="/admin/advertising" element={<AdvertisingDashboard />} />
      <Route path="/admin/advertising/advertisers" element={<AdvertisingAdvertisers />} />
      <Route path="/admin/advertising/screens" element={<AdvertisingScreens />} />
      <Route path="/admin/advertising/campaigns" element={<AdvertisingCampaigns />} />
      <Route path="/admin/advertising/calendar" element={<AdvertisingCalendar />} />
      <Route path="/admin/advertising/approvals" element={<AdvertisingApprovals />} />
      <Route path="/admin/advertising/proof-of-play" element={<AdvertisingProofOfPlay />} />
      <Route path="/admin/advertising/billing" element={<AdvertisingBilling />} />
      {/* Advertiser Self-Service Portal */}
      <Route path="/advertiser/login" element={<AdvertiserLogin />} />
      <Route path="/advertiser/magic-login" element={<AdvertiserLogin />} />
      <Route path="/advertiser" element={<AdvertiserDashboard />} />
      <Route path="/advertiser/campaigns" element={<AdvertiserCampaigns />} />
      <Route path="/advertiser/campaigns/new" element={<CreateCampaign />} />
      <Route path="/advertiser/campaigns/:campaignId" element={<CampaignDetail />} />
      <Route path="/advertiser/billing" element={<AdvertiserBilling />} />
      <Route path="/advertiser/billing/success" element={<AdvertiserBilling />} />
      
      {/* Visit Routes (Mobile QR Scan) */}
      <Route path="/visit/:qrCodeId" element={<VisitCapture />} />
      <Route path="/visit/success" element={<VisitSuccess />} />
      
      {/* Screen Player (Signage Display) */}
      <Route path="/player/:screenId" element={<ScreenPlayer />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
